import { Injectable, inject, signal } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, tap } from 'rxjs';
import { AppEnvironment } from 'sham-components/services';

export interface LoginResponse {
  accessToken: string;
  accessTokenExpiresAtUtc: string;
  refreshToken: string;
  refreshTokenExpiresAtUtc: string;
  user: any;
}

@Injectable({
  providedIn: 'root',
})
export class Auth {
  private readonly appEnv = inject(AppEnvironment);
  private readonly http = inject(HttpClient);
  readonly user = signal<any>(null);

  login(credentials: any): Observable<LoginResponse> {
    return this.http
      .post<LoginResponse>(this.appEnv.API_BASE_URL() + '/v1/auth/login', credentials)
      .pipe(
        tap((response) => {
          this.user.set(response.user);
          if (typeof globalThis !== 'undefined' && globalThis.localStorage) {
            globalThis.localStorage.setItem('token', response.accessToken);
            globalThis.localStorage.setItem('refreshToken', response.refreshToken);
          }
        }),
      );
  }

  signIn(username: string) {
    this.user.set(username);
  }
}
